import getLastBar from "../../methods/getLastBar";
import getIsLastBarEmpty from "../../methods/getIsLastBarEmpty";
import { ISignature, IBar, IScore } from "../../../../../common/types";

const getLastSignature = (signatures: ISignature[], bar: number, bars: IBar[], score: IScore): ISignature => {
    let lastSignature;
    const lastBar = getLastBar(score);
    const isLastBarInScoreEmpty = getIsLastBarEmpty(score);

    for (let i = 0; i <= bar; i++) {
        let signatureIndex = signatures.findIndex(signature => signature.bar === i);
        if (signatureIndex !== -1) {
            lastSignature = signatures[signatureIndex] as ISignature;
            if (bar === lastSignature.bar) return lastSignature;
        }
    }
    if (bars[bar].notes.length !== 0 || lastBar !== bar || !isLastBarInScoreEmpty) {
        return { ...lastSignature, display: false } as ISignature;
    } else {
        return { ...lastSignature, ghost: true } as ISignature;
    }
};

export default getLastSignature;
